import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

/**
 * Lightweight error logger — sends errors to MongoDB via backend.
 * Replaces console.error for production monitoring.
 */
export async function logError(source, message, context = null) {
  try {
    await axios.post(`${API}/errors/log`, { source, message, context }, { withCredentials: true });
  } catch (loggingErr) {
    // Fallback: write to sessionStorage for later retrieval. Do NOT call logError again.
    try {
      const errors = JSON.parse(sessionStorage.getItem('sfw_errors') || '[]');
      errors.push({ source, message, ts: Date.now() });
      if (errors.length > 20) errors.shift();
      sessionStorage.setItem('sfw_errors', JSON.stringify(errors));
    } catch (storageErr) {
      // Absolute last resort — log to console so errors are not completely silent
      if (process.env.NODE_ENV !== 'production') {
        console.warn('[errorLogger] Failed to persist error:', source, message, storageErr);
      }
    }
  }
}
